// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLinkOutlinedSvg from "@fishx/icons-svg/es/asn/PLinkOutlined";
import FishxIcon from '../components/FishxIcon';

var PLinkOutlined = function PLinkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLinkOutlinedSvg
  }));
};

PLinkOutlined.displayName = 'PLinkOutlined';
export default React.forwardRef(PLinkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLinkOutlined.js
// module id = 3494
// module chunks = 0